export const localeData = [
  {
    value: 'zh-CN',
    label: '中文 (简体)',
  },
  {
    value: 'zh-HK',
    label: '中文 (繁體)',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'ja',
    label: '日文',
  },
  {
    value: 'ptbr',
    label: 'Potugues',
  },
  {
    value: 'it-CH',
    label: 'Italiano',
  },
  {
    value: 'fr-CH',
    label: 'français',
  },
];

export const getDefaultLocale = locale => {
  if (locale === 'zh-cn' || locale === 'zh') {
    return 'zh-CN'
  }

  if (locale === 'zh-hk' || locale === 'zh-tw') {
    return 'zh-HK'
  }

  const filterLocale = localeData.filter(item => {
    if (item.value === locale) {
      return item
    }
    return null;
  })

  if (filterLocale.length) {
    return filterLocale[0].value;
  }

  return 'zh-CN'
}
